import React from "react";
import "./whatIdo.css";

const cards = [
  {
    icon: "🎙️",
    title: "AI Voice Agents & Agentic Systems",
    points: [
      "Real-time voice agents with realtime models and LiveKit",
      "Agentic RAG systems with reasoning, tool usage, and MCP integrations",
    ],
  },
  {
    icon: "💻",
    title: "Full-Stack Development",
    points: [
      "Responsive frontends with React & Redux",
      "Robust backends and APIs with FastAPI, Node.js, and Express",
      "Production-grade products end to end, from data model to UI",
    ],
  },
  {
    icon: "☁️",
    title: "Cloud & Backend Engineering",
    points: [
      "Scalable services on AWS — ECS, Lambda, EC2, S3, and DynamoDB",
      "MCP integrations and streaming pipelines across PostgreSQL, DocumentDB, CloudWatch",
      "Production deployments, migrations, testing, and performance optimization",
    ],
  },
];

export default function WhatIdo() {
  return (
    <section className="section section--soft" id="whatido">
      <div className="section-inner">
        <h2 className="section-title">What I Do</h2>
        <span className="section-title-accent" />
        <p className="section-subtitle">
          Turning ambitious AI and product ideas into reliable systems in production.
        </p>

        <div className="whatido-grid">
          {cards.map((c) => (
            <div className="whatido-card" key={c.title}>
              <div className="whatido-icon">{c.icon}</div>
              <h3 className="whatido-card-title">{c.title}</h3>
              <ul className="whatido-list">
                {c.points.map((p, i) => (
                  <li key={i}>{p}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
